import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AsyncPipe, NgIf } from '@angular/common';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SessionStateService } from '../../../core/services/session/session-state.service';
import { AuthService } from '../../../core/services/auth/auth.service';
import { StorageService } from '../../../core/services/storage/storage.service';

@Component({
    selector: 'app-session-expired-banner',
    imports: [NgIf, AsyncPipe, TranslateModule],
    templateUrl: './session-expired-banner.component.html',
    styleUrls: ['./session-expired-banner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SessionExpiredBannerComponent {
  private readonly sessionState = inject(SessionStateService);
  private readonly authService = inject(AuthService);
  private readonly storageService = inject(StorageService);
  private readonly router = inject(Router);

  protected readonly expired$ = this.sessionState.sessionExpired$;

  protected reconnect(): void {
    this.authService.logout().catch(() => undefined).finally(() => {
      this.storageService.clear();
      localStorage.removeItem('user');
      this.sessionState.clearExpired();
      this.router.navigate(['/authentication/login'], {
        queryParams: { disconnected: 'session' }
      });
    });
  }
}
